import React from 'react';
import Link from 'next/link';
import { ArrowBackIcon, Card } from '@avila-tek/ui/src';

export interface FormHeaderProps {
  href?: string;
  title: string;
  backBtnText?: string;
}

function FormHeader({ href, title, backBtnText }: FormHeaderProps) {
  return (
    <Card.Header>
      {title}
      {href ? (
        <Link href={href}>
          <div className="flex gap-1 text-purple-300 font-medium items-center relative z-10">
            <ArrowBackIcon className="w-4 h-4" />
            {backBtnText}
          </div>
        </Link>
      ) : null}
    </Card.Header>
  );
}

export default FormHeader;
